import RecycleFundamentals from './RecycleFundamentals';

export default RecycleFundamentals;
